module.exports = __webpack_public_path__ + "img/new_btn_tablast.8cb0e2a0.png";